import React from 'react';
import { cn } from '@/lib/utils';
import { PRESETS, PRESET_LABELS, getRangeForPreset, getPresetForRange } from '@/utils/dateRangePresets';

/**
 * Scrollable period chips for dashboard date range (aligned with mobile).
 */
const PeriodChips = ({ startDate, endDate, onChange, className = '' }) => {
  const selectedPreset = getPresetForRange(startDate, endDate);

  const handleClick = (preset) => {
    if (preset === 'custom') return;
    const range = getRangeForPreset(preset);
    if (range) onChange(range);
  };

  return (
    <div className={cn('overflow-x-auto overflow-y-hidden pb-1 -mx-1', className)}>
      <div className="flex gap-2 min-w-max px-1">
        {PRESETS.map((preset) => {
          const isSelected = selectedPreset === preset;
          return (
            <button
              key={preset}
              type="button"
              onClick={() => handleClick(preset)}
              className={cn(
                'shrink-0 rounded-lg px-4 py-2 text-sm font-medium transition-colors',
                'border',
                isSelected
                  ? 'bg-primary text-primary-foreground border-primary'
                  : 'bg-muted hover:bg-muted/80 text-foreground border-border'
              )}
            >
              {PRESET_LABELS[preset]}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PeriodChips;
